import React, {useMemo} from "react";
import AdminLayout from "@widgets/layout/AdminLayout";
import router, {Route} from "@/routing/Router";
import DayReportOverview from "@components/widgets/reports/dayReport/DayReportOverview";

const DayReport = () => {
    const route: Route = useMemo(() => router.dayReport, []);

    return (
        <AdminLayout currentPage={route}>
            <DayReportOverview route={route}/>
        </AdminLayout>
    );
};

export default DayReport;